import { User } from "@iventis/domain-model/model/user";
import { permissionsApi } from "@iventis/api/src/api";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";

export function getProjectAdmins(projectId: string): Promise<User[]> {
    return permissionsApi.get(`projects/${projectId}/administrators`).then(({ data }) => data);
}

export function removeProjectAdmin(userId: string, projectId: string) {
    return permissionsApi.delete(`projects/${projectId}/administrators/${userId}`, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.generic.title, { action: translate(Content.people.removeFromTeamTitle)?.toLocaleLowerCase?.() }),
            message: translate(Content.errors.custom_network_error.generic.message, { action: translate(Content.people.removeFromTeamTitle) }),
        },
    });
}

export function setProjectAdmin(userId: string, projectId: string) {
    return permissionsApi.post(`projects/${projectId}/administrators/${userId}`, undefined, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.generic.title, { action: translate(Content.people.addTeamMember)?.toLocaleLowerCase?.() }),
            message: translate(Content.errors.custom_network_error.generic.message, { action: translate(Content.people.addTeamMember) }),
        },
    });
}
